//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {read} from 'gso-session';
import outside from 'vue-outside';
import AccounCircleIcon from 'gso-design-icons/vue/material-design/account_circle.vue';
import resolveUrl from '../mixins/resolve-url';

function username() {
	const user = read('user');
	return user && `${user.firstName || user.lastName}`;
}

function fullname() {
	const user = read('user');
	return user && `${user.firstName || ''} ${user.lastName}`;
}

export default {
	name: 'account',
	components: {
		AccounCircleIcon
	},
	directives: {
		outside
	},
	mixins: [resolveUrl],
	data() {
		return {
			username: username(),
			fullname: fullname()
		};
	},
	computed: {
		isOpen() {
			return this.$store.state.header.isOpen === 'account';
		}
	},
	methods: {
		goToMyAccount() {
			window.location = this.resolveUrl('../myaccount');
		},
		outside(event, el) {
			if (el.parentElement && !el.parentElement.contains(event.target)) {
				if (this.isOpen) {
					this.$store.commit('header/close');
				}
			}
		}
	}
};
